module.exports = __webpack_public_path__ + "static/media/OmniFlix.f7f46931.svg";